var map = {
	"./close.svg": 753,
	"./envelope.svg": 151,
	"./facebook.svg": 243,
	"./globe.svg": 854,
	"./instagram.svg": 473,
	"./linkedin.svg": 445,
	"./offsite-link.svg": 980,
	"./phone.svg": 197,
	"./search.svg": 624,
	"./twitter.svg": 468,
	"./youtube.svg": 994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;